/**
 * @generated SignedSource<<55587c634999b5cbeb6fccfa17664e09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion$data = {
  readonly status: RoutineOccasionStatus;
  readonly totalTaskExecutionCount: number | null;
  readonly " $fragmentType": "WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion";
};
export type WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion$key = {
  readonly " $data"?: WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "calculateNoTasks",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "calculateNotCompletedStarted",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "status",
      "storageKey": "status(calculateNoTasks:true,calculateNotCompletedStarted:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTaskExecutionCount",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "b1d4be9a9aaa0ee64f2c78324cc0bf48";

export default node;
